import { useCatalogsStore } from "stores/catalogs";

export const makeLangUrl = (path: string, lang?: string): string => {
  const { languages } = useCatalogsStore.getState();
  const validLangs = languages?.map((l) => l.isoCode.toLowerCase()) || ["en"];
  const segments = path.split("/").filter(Boolean);
  // Если язык уже есть в пути, заменяем его
  if (validLangs.includes(segments[0])) {
    segments.shift();
  }
  // Добавляем новый язык, если он указан
  if (lang && validLangs.includes(lang.toLowerCase())) {
    segments.unshift(lang.toLowerCase());
  }

  // Если массив пуст, значи мы на главной
  let urlResult =
    segments && segments.length > 0 ? `/${segments.join("/")}/` : "/";

  if (urlResult.includes("?") && urlResult.endsWith("/")) {
    urlResult = urlResult.slice(0, -1); // Удаляем последний слеш, если есть query-параметры
  }

  return urlResult;
};
